/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RouteDtoModel, RouteDtoModelType } from "./RouteDtoModel"
import { RouteDtoModelSelector } from "./RouteDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  route: RouteDtoModelType;
}

/**
 * RouteStagedEditDiscardedDtoBase
 * auto generated base class for the model RouteStagedEditDiscardedDtoModel.
 *
 * Route staged edit discarded event
 */
export const RouteStagedEditDiscardedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('RouteStagedEditDiscardedDto')
  .props({
    __typename: types.optional(types.literal("RouteStagedEditDiscardedDto"), "RouteStagedEditDiscardedDto"),
    /** Payload of route staged edit discarded */
    route: types.union(types.undefined, MSTGQLRef(types.late((): any => RouteDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class RouteStagedEditDiscardedDtoModelSelector extends QueryBuilder {
  route(builder: string | RouteDtoModelSelector | ((selector: RouteDtoModelSelector) => RouteDtoModelSelector) | undefined) { return this.__child(`route`, RouteDtoModelSelector, builder) }
}
export function selectFromRouteStagedEditDiscardedDto() {
  return new RouteStagedEditDiscardedDtoModelSelector()
}

export const routeStagedEditDiscardedDtoModelPrimitives = selectFromRouteStagedEditDiscardedDto()
